module.exports = __webpack_public_path__ + "static/img/meimengchengzhen_icon.7a15e54.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/meimengchengzhen_icon.png
// module id = K58R
// module chunks = 1